import { createMultiStyleConfigHelpers as r } from "@chakra-ui/react";
import { iconSizeStyles as o } from "../../foundations/icons.mjs";
import a from "../../foundations/z-index.mjs";
const { defineMultiStyleConfig: l, definePartsStyle: e } = r([
  "container",
  "menubar",
  "category",
  "group",
  "menuItem",
  "slider"
]), t = 94, s = 334, n = e({
  container: {
    display: "flex",
    flexDir: "column",
    backgroundColor: "white"
  },
  menubar: {
    display: "flex",
    flexDir: "column"
  },
  category: {
    cursor: "pointer",
    textDecoration: "none"
  },
  menuItem: {
    display: "flex",
    flexDir: "row",
    cursor: "pointer",
    textDecoration: "none",
    "&[aria-disabled]": {
      cursor: "not-allowed",
      opacity: 0.5
    }
  }
}), i = e({
  container: {
    minH: "100vh",
    pos: "sticky",
    background: "teal.500",
    zIndex: a.modal
  },
  category: {
    display: "flex",
    flexDir: "column",
    background: "teal.500",
    gap: 2,
    alignItems: "center",
    color: "white",
    width: `${t}px`,
    paddingTop: 4,
    paddingX: 2,
    paddingBottom: "15px",
    borderBottom: "1px solid var(--sgi-colors-blackAlpha-200)",
    span: {
      textStyle: "bodyBoldSmall",
      lineHeight: "20px",
      textAlign: "center"
    },
    svg: {
      ...o["2xl"]
    },
    _hover: {
      backgroundColor: "teal.600"
    },
    _active: {
      color: "white"
    },
    _focusVisible: {
      outline: "none",
      boxShadow: "outline",
      zIndex: 1
    },
    "&[aria-expanded=true]": {
      backgroundColor: "white",
      color: "teal.700",
      _hover: {}
    },
    "&.category-active": {
      backgroundColor: "teal.700",
      color: "white",
      _hover: {
        backgroundColor: "teal.600",
        color: "white"
      },
      _focusVisible: {
        outline: "none",
        boxShadow: "outline",
        zIndex: 1
      }
    }
  },
  slider: {
    position: "absolute",
    top: "0",
    left: `${t}px`,
    height: "full",
    minHeight: "100%",
    overflow: "hidden",
    backgroundColor: "white",
    boxShadow: "4px 4px 6px -2px rgba(0, 0, 0, 0.05), 10px 10px 15px -3px rgba(0, 0, 0, 0.10)",
    zIndex: a.modal
  },
  group: {
    flexDir: "column",
    gap: 2,
    minWidth: "191px",
    paddingBottom: 6,
    borderBottom: "1px solid var(--sgi-colors-gray-100)",
    marginBottom: 6,
    p: {
      textStyle: "bodyBoldSmall"
    }
  },
  menuItem: {
    gap: 2,
    paddingY: "0.5",
    paddingX: "4",
    color: "teal.600",
    minWidth: "191px",
    marginBottom: 1,
    span: {
      flex: 1,
      textStyle: "bodySmall"
    },
    svg: {
      marginTop: 1
    },
    _hover: {
      backgroundColor: "gray.100",
      color: "teal.700",
      borderRadius: "lg"
    },
    _focusVisible: {
      outline: "none",
      boxShadow: "outline"
    },
    "&[aria-current]": {
      color: "teal.700",
      backgroundColor: "teal.100",
      borderRadius: "lg",
      _hover: {
        backgroundColor: "gray.100"
      }
    }
  }
}), d = e({
  container: {
    width: "100%"
  },
  menubar: {
    gap: 2
  },
  category: {
    display: "flex",
    flexDir: "row",
    gap: 4,
    paddingX: 6,
    paddingY: 2,
    alignItems: "center",
    span: {
      textStyle: "bodyBold",
      color: "gray.800"
    },
    svg: {
      ...o.xl,
      color: "teal.500",
      "&[data-icon=chevron-down], &[data-icon=chevron-up]": {
        ...o.md
      }
    },
    _hover: {
      backgroundColor: "gray.100",
      svg: {
        color: "teal.600"
      }
    },
    "&.category-active": {
      backgroundColor: "teal.100",
      svg: {
        color: "teal.700"
      },
      _hover: {
        backgroundColor: "gray.100"
      },
      _focusVisible: {
        outline: "none",
        boxShadow: "outline"
      }
    }
  },
  group: {
    flexDir: "column",
    gap: 2,
    marginBottom: 2,
    p: {
      textStyle: "bodyBold",
      paddingLeft: "62px",
      paddingRight: 6,
      paddingY: 2
    }
  },
  menuItem: {
    gap: 2,
    paddingLeft: "60px",
    paddingRight: 6,
    paddingY: 2,
    textStyle: "body",
    marginBottom: 2,
    span: {
      flex: 1
    },
    svg: {
      marginTop: 1
    },
    _hover: {
      backgroundColor: "gray.100",
      color: "teal.600"
    },
    "&[aria-current]": {
      color: "teal.700",
      backgroundColor: "teal.100",
      _hover: {
        backgroundColor: "gray.100"
      }
    }
  }
}), u = l({
  baseStyle: n,
  variants: {
    desktop: i,
    mobile: d
  },
  defaultProps: {
    variant: "desktop"
  }
});
export {
  u as default,
  t as globalNavMainWidth,
  s as maxGlobalNavWidth
};
